import { render, staticRenderFns } from "./ModulesListDialog.vue?vue&type=template&id=b636a7e8"
import script from "./ModulesListDialog.vue?vue&type=script&lang=js"
export * from "./ModulesListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports